import SearchResultLayoutProvider from './hooks/useSearchResultLayout';
import Container from './handles/Container';

import { SearchResultLayoutProps } from './@types/SearchResultLayoutProps';
import './style.css';

type CanvasWidth = {
	canvasWidth: 1080 | 1024 | 640;
};

type AllProps = SearchResultLayoutProps & CanvasWidth;

const Desktop = (props: AllProps) => (
	<SearchResultLayoutProvider {...props}>
		{props.canvasWidth > 1024 ? <Container>{props.children}</Container> : <></>}
	</SearchResultLayoutProvider>
);

const Mobile = (props: AllProps) => (
	<SearchResultLayoutProvider {...props}>
		{props.canvasWidth <= 1024 ? <Container>{props.children}</Container> : <></>}
	</SearchResultLayoutProvider>
);

export const SearchResultLayout = { Desktop, Mobile };
